import { useLocales } from 'src/locales'

export const useDefaultSortingItem = () => {
  const { t } = useLocales()

  const defaultSortingOption = { value: '', label: t('common.default') }

  return { defaultSortingOption }
}
